<div class="eui-dashboard-card {{styleClass}} {{stateTypeClass}}" tabindex="1" [class.row]="isHorizontalLayout"
    [class.eui-dashboard-card--clickable]="isClickable" [class.eui-dashboard-card--icon-compact]="isIconCompact"
    [class.eui-dashboard-card--horizontal]="isHorizontalLayout"
    [class.eui-dashboard-card--horizontal--icon-compact]="isIconCompact && isHorizontalLayout" (click)="onClick($event)"
    (keydown)="onKeyDown($event.keyCode)" attr.data-e2e="{{ e2eAttr }}">

    <div *ngIf="iconClass" [class.col-4]="isHorizontalLayout" class="eui-dashboard-card__icon-container">
        <div class="eui-dashboard-card__icon-wrapper eui-dashboard-card__icon-wrapper--{{iconTypeClass}}">
            <span class="{{iconClass}} eui-icon-fw eui-dashboard-card__icon-wrapper-icon"></span>
        </div>
    </div>

    <div *ngIf="imageUrl" [class.col-4]="isHorizontalLayout" class="eui-dashboard-card__image-container">
        <div class="eui-dashboard-card__image-wrapper">
            <img [style.height.px]="imageHeight" [style.width.px]="imageWidth" src="{{imageUrl}}" alt="{{imageUrl}}" />
        </div>
    </div>

    <div class="eui-dashboard-card__content-wrapper" [class.col-8]="isHorizontalLayout">
        <div class="eui-dashboard-card__content">
            <div class="eui-dashboard-card__content-label eui-dashboard-card__content-label--lines-{{labelMaxLines}}">
                {{label}}</div>
            <div
                class="eui-dashboard-card__content-sub-label eui-dashboard-card__content-sub-label--lines-{{subLabelMaxLines}}">
                {{subLabel}}
            </div>
            <div *ngIf="!isClickable" class="eui-dashboard-card__content-link">
                <a *ngIf="urlExternal" href="{{urlExternal}}" target="{{urlExternalTarget}}"
                    class="btn {{buttonStyleClass}}" tabindex="1">{{buttonLinkLabel}}</a>
                <a *ngIf="url" [routerLink]="[url]" class="btn {{buttonStyleClass}}"
                    tabindex="1">{{buttonLinkLabel}}</a>
            </div>
        </div>
    </div>
</div>
